import { render, staticRenderFns } from "./QueueCheck.vue?vue&type=template&id=53518ed7&scoped=true&"
import script from "./QueueCheck.vue?vue&type=script&lang=ts&"
export * from "./QueueCheck.vue?vue&type=script&lang=ts&"
import style0 from "./QueueCheck.vue?vue&type=style&index=0&id=53518ed7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53518ed7",
  null
  
)

export default component.exports